module.exports = __webpack_public_path__ + "static/media/imagem16.94224570.jpeg";